import {
  Box,
  Button,
  CardContent,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme
} from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import logoSalvador from 'assets/images/logo-salvador.png';
import { useRef } from 'react';
import { useState } from 'react';

const AllianceView = () => {
  const theme = useTheme();
  const [hideContentTable, setHideContentTable] = useState(false);

  const handleHideContentTable = () => {
    setHideContentTable(!hideContentTable);
  };

  const styles = {
    title: {
      marginTop: 3,
      paddingBottom: 2,
      fontSize: 18,
      fontWeight: 'bold',
      color: '#2f5496'
    },
    subTitle: {
      marginTop: 2,
      paddingBottom: 2,
      fontSize: 15,
      color: '#2f5496'
    },
    content: {
      paddingLeft: 4,
      marginTop: 1,
      paddingBottom: 2,
      fontSize: 15,
      textAlign: 'justify',
      color: '#000'
    },
    divider: {
      borderBottom: `2px solid #002060`,
      marginTop: 5
    },
    list: {
      listStyle: 'lower-latin',
      paddingLeft: 8
    },
    listBall: {
      listStyle: 'disc',
      paddingLeft: 8
    },
    listContent: {
      listStyle: 'none',
      paddingLeft: 0
    },
    listItem: {
      display: 'list-item',
      fontWeight: 'bold',
      paddingTop: 0,
      color: '#000'
    },
    listItemContent: {
      cursor: 'pointer',
      display: 'list-item',
      fontWeight: 'bold',
      paddingTop: 0,
      color: '#000',
      '& span': {
        fontWeight: 'bold'
      }
    },
    listSubItemContent: {
      cursor: 'pointer',
      display: 'list-item',
      paddingTop: 0,
      color: '#000',
      '& span': {
        fontWeight: 'light'
      },
      textDecoration: 'underline'
    },
    referenceLink: {
      fontSize: '0.5em',
      verticalAlign: 'top',
      textDecoration: 'none',
      color: 'blue',
      marginRight: '2px'
    },
    table: {
      minWidth: 400,
      width: '90%',
      marginLeft: '50px'
    }
  };

  const contentRefs = {
    antecedentes: useRef(null),
    alianza: useRef(null),
    compromisos: useRef(null),
    google: useRef(null),
    goes: useRef(null),
    estructuraAdministrativa: useRef(null),
    comiteEjecutivo: useRef(null),
    comiteDirectivo: useRef(null),
    decisiones: useRef(null),
    acuerdoMaestro: useRef(null),
    caracteristicas: useRef(null),
    responsabilidad: useRef(null),
    vigenciaTerminacion: useRef(null),
    confidencialidad: useRef(null),
    cesionSubcontratacion: useRef(null),
    leyAplicable: useRef(null),
    impuestos: useRef(null),
    controversiaFacturas: useRef(null),
    pagosVencidos: useRef(null),
    propiedadIntelectual: useRef(null),
    exencionResponsabilidad: useRef(null),
    terminacionConveniencia: useRef(null),
    cesion: useRef(null),
    fuerzaMayor: useRef(null),
    firmasElectronicas: useRef(null),
    afiliadas: useRef(null),
    descuentos: useRef(null),
    descuentoEnterprise: useRef(null),
    porcentajesDescuento: useRef(null),
    descuentoComputeEngine: useRef(null),
    descuentoPrecioFijo: useRef(null),
    descuentosLooker: useRef(null),
    descuentosChronicle: useRef(null),
    descuentosMandiant: useRef(null),
    aplicacionDescuentos: useRef(null),
    exclusionesDescuentos: useRef(null),
    extensionDescuentos: useRef(null),
    modificaciones: useRef(null),
    infraestructura: useRef(null)
  };

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <MainCard
      style={{ marginTop: '20px', paddingBottom: '5px' }}
      title={
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={12}>
            <Typography variant="h1" component="h2">
              Acuerdo de Alianza Estratégica
            </Typography>
            <Typography variant="h4"> Gobernanza y Procedimientos </Typography>
          </Grid>
        </Grid>
      }
      secondary={
        <Grid container justifyContent={'center'}>
          <Box>
            <img src={logoSalvador} alt="Logo Salvador" style={{ height: '80px', width: 'auto', color: theme.palette.grey[500] }} />
          </Box>
        </Grid>
      }
    >
      <Box mt={2}>
        <Button variant="outlined" onClick={handleHideContentTable}>
          {!hideContentTable ? 'Mostrar tabla de contenido' : 'Ocultar tabla de contenido'}
        </Button>
      </Box>

      <CardContent>
        {hideContentTable && (
          <>
            <Typography sx={styles.title}>Tabla de contenido</Typography>
            <List sx={styles.listContent}>
              <ListItem sx={styles.listItemContent}>
                <ListItemText primary="Antecedentes" onClick={() => scrollToSection(contentRefs.antecedentes)} />
              </ListItem>
              <ListItem sx={styles.listItemContent}>
                <ListItemText
                  primary="Alianza Estratégica Google - Gobierno de El Salvador"
                  onClick={() => scrollToSection(contentRefs.alianza)}
                />
              </ListItem>
              <ListItem sx={styles.listItemContent}>
                <ListItemText
                  primary="Compromisos Mínimos y Disposiciones relativas a los Servicios"
                  onClick={() => scrollToSection(contentRefs.compromisos)}
                />
                <List sx={styles.listContent}>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Google" onClick={() => scrollToSection(contentRefs.google)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="GOES" onClick={() => scrollToSection(contentRefs.goes)} />
                  </ListItem>
                </List>
              </ListItem>
              <ListItem sx={styles.listItemContent}>
                <ListItemText
                  primary="Estructura administrativa de la Alianza"
                  onClick={() => scrollToSection(contentRefs.estructuraAdministrativa)}
                />
                <List sx={styles.listContent}>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Comité Ejecutivo" onClick={() => scrollToSection(contentRefs.comiteEjecutivo)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Comité Directivo Conjunto" onClick={() => scrollToSection(contentRefs.comiteDirectivo)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Decisiones" onClick={() => scrollToSection(contentRefs.decisiones)} />
                  </ListItem>
                </List>
              </ListItem>
              <ListItem sx={styles.listItemContent}>
                <ListItemText
                  primary="Acuerdo Maestro de Google Cloud – Cloud Master Agreement (CMA)"
                  onClick={() => scrollToSection(contentRefs.acuerdoMaestro)}
                />
                <List sx={styles.listContent}>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Características de la Identificación"
                      onClick={() => scrollToSection(contentRefs.caracteristicas)}
                    />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Responsabilidad" onClick={() => scrollToSection(contentRefs.responsabilidad)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Vigencia y Terminación" onClick={() => scrollToSection(contentRefs.vigenciaTerminacion)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Confidencialidad" onClick={() => scrollToSection(contentRefs.confidencialidad)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Cesión y subcontratación" onClick={() => scrollToSection(contentRefs.cesionSubcontratacion)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Ley aplicable y resolución de controversias"
                      onClick={() => scrollToSection(contentRefs.leyAplicable)}
                    />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Impuestos" onClick={() => scrollToSection(contentRefs.impuestos)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Controversia sobre las facturas"
                      onClick={() => scrollToSection(contentRefs.controversiaFacturas)}
                    />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Pagos vencidos" onClick={() => scrollToSection(contentRefs.pagosVencidos)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Propiedad Intelectual" onClick={() => scrollToSection(contentRefs.propiedadIntelectual)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Exención de responsabilidad"
                      onClick={() => scrollToSection(contentRefs.exencionResponsabilidad)}
                    />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Vigencia y Terminación" onClick={() => scrollToSection(contentRefs.vigenciaTerminacion)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Terminación por Conveniencia"
                      onClick={() => scrollToSection(contentRefs.terminacionConveniencia)}
                    />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Cesión" onClick={() => scrollToSection(contentRefs.cesion)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Fuerza Mayor" onClick={() => scrollToSection(contentRefs.fuerzaMayor)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Cesión" onClick={() => scrollToSection(contentRefs.cesion)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Firmas Electrónicas" onClick={() => scrollToSection(contentRefs.firmasElectronicas)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Afiliadas" onClick={() => scrollToSection(contentRefs.afiliadas)} />
                  </ListItem>
                </List>
              </ListItem>
              <ListItem sx={styles.listItemContent}>
                <ListItemText primary="Descuentos" onClick={() => scrollToSection(contentRefs.descuentos)} />
                <List sx={styles.listContent}>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Descuento Enterprise" onClick={() => scrollToSection(contentRefs.descuentoEnterprise)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Porcentajes de descuento" onClick={() => scrollToSection(contentRefs.porcentajesDescuento)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Descuento de Compute Engine Flex CUD"
                      onClick={() => scrollToSection(contentRefs.descuentoComputeEngine)}
                    />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Descuento de precio fijo para GDC-E SKU"
                      onClick={() => scrollToSection(contentRefs.descuentoPrecioFijo)}
                    />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Descuentos de Looker" onClick={() => scrollToSection(contentRefs.descuentosLooker)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Descuentos de Chronicle" onClick={() => scrollToSection(contentRefs.descuentosChronicle)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Descuentos de Mandiant" onClick={() => scrollToSection(contentRefs.descuentosMandiant)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Aplicación de Descuentos" onClick={() => scrollToSection(contentRefs.aplicacionDescuentos)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText primary="Exclusiones de Descuentos" onClick={() => scrollToSection(contentRefs.exclusionesDescuentos)} />
                  </ListItem>
                  <ListItem sx={styles.listSubItemContent}>
                    <ListItemText
                      primary="Extensión de Descuentos a Nuevos Servicios y SKUs"
                      onClick={() => scrollToSection(contentRefs.extensionDescuentos)}
                    />
                  </ListItem>
                </List>
              </ListItem>
              <ListItem sx={styles.listItemContent}>
                <ListItemText primary="Modificaciones" onClick={() => scrollToSection(contentRefs.modificaciones)} />
              </ListItem>
              <ListItem sx={styles.listItemContent}>
                <ListItemText primary="Infraestructura digital" onClick={() => scrollToSection(contentRefs.infraestructura)} />
              </ListItem>
            </List>
          </>
        )}

        <Typography sx={styles.title} ref={contentRefs.antecedentes}>
          Antecedentes
        </Typography>
        <Typography sx={styles.content}>
          La República de El Salvador en su interés de impulsar la transformación digital del Estado a través del uso eficiente de recursos
          y optimización de costos, decidió materializar una Alianza Estratégica para cumplir dicho propósito el pasado agosto de 2023.
          Esto, buscando la adopción de servicios de computación en la nube, asesorías especializadas, ciberseguridad y hardware, que
          cuenten con ofertas más favorables, descuentos y tecnologías anticipadas que puedan ser utilizadas de manera sostenible en el
          país, por medio de Google como Socio Estratégico.
        </Typography>

        <Typography sx={styles.divider} />

        <Typography sx={styles.title} ref={contentRefs.alianza}>
          Alianza Estratégica Google - Gobierno de El Salvador
        </Typography>
        <Typography sx={styles.content}>
          El Acuerdo, es un documento exhaustivo y vinculante que desarrolla esta Alianza estructurada entre Google y El Gobierno de El
          Salvador, centrada en la implementación de soluciones tecnológicas y la modernización digital del Estado. Este documento,
          establece los compromisos mínimos que deben cumplir Google y el Estado, la estructura administrativa que rige el Acuerdo y los
          mecanismos de afiliación a los que podrán optar las instituciones que quisieran acceder a los servicios tecnológicos. Además,
          contiene la estructura administrativa que rige el Acuerdo, encargada de supervisar, coordinar y atender las controversias que
          puedan surgir durante la implementación de este.
        </Typography>
        <Typography sx={styles.content}>A continuación, podrán encontrar</Typography>

        <Typography sx={styles.title} ref={contentRefs.compromisos}>
          Compromisos Mínimos y Disposiciones relativas a los Servicios:
        </Typography>
        <Typography sx={styles.subTitle} ref={contentRefs.google}>
          Google:
        </Typography>
        <List sx={styles.list}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Constituir una persona jurídica en la República de El Salvador" />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Oficina de Google Cloud en la República de El Salvador" />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Buscar la implementación de una Instancia Propuesta de Google Cloud Platform" />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Establecer una entidad legal local y una oficina de Google, para realizar actividades de ventas y mercadotecnia, así como administrar la Instancia Propuesta de GDC" />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Trabajar en conjunto con un socio integrador de sistemas de terceros para la instalación y el mantenimiento." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Actuar como proveedor de interconexión asociado junto a proveedores locales." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Identificación y contratación de un espacio de colocación local que pueda alojar y dar soporte a equipos desplegados por GDC." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Obtener aprobaciones y permisos necesarios para que pueda cumplir con la Instancia Propuesta de GDC." />
          </ListItem>
        </List>
        <Typography sx={styles.subTitle} ref={contentRefs.goes}>
          GOES:
        </Typography>
        <List sx={styles.list}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Celebrar un contrato mutuamente aceptable para la compra de un monto mínimo de USD$ 500 millones de dólares durante un período de no menos de siete (7) años, de los cuales al menos USD 300$ millones asignados a determinados servicios de Google Cloud." />
          </ListItem>
        </List>

        <Typography sx={styles.title} ref={contentRefs.estructuraAdministrativa}>
          Estructura administrativa de la Alianza
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.comiteEjecutivo}>
          Comité Ejecutivo
        </Typography>
        <Typography sx={styles.content}>
          El Acuerdo será gobernado por un Comité Ejecutivo compuesto por dos Directores Ejecutivos, uno representante del Ministerio de
          Relaciones Exteriores y otro de Google, así como seis Interesados Técnicos, también con un representante de cada entidad. Este
          Comité estará activo durante el desarrollo del Acuerdo de Alianza Estratégica (AFA) y tendrá las siguientes responsabilidades:
        </Typography>

        <List sx={styles.list}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Supervisar el desempeño y la alineación de las partes involucradas en el desarrollo del acuerdo." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Supervisar a sus respectivos ejecutivos." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Resolver controversias y asuntos escalados que no hayan sido resueltos por el Comité Directivo Conjunto (CDC)." />
          </ListItem>
        </List>

        <Typography sx={styles.content}>
          El Comité se reunirá al menos dos veces al año y podrá designar un presidente y un secretario para las reuniones, decisión que
          tomarán los Directores Ejecutivos. El secretario del Gobierno será el presidente del Ministerio de Relaciones Exteriores.
        </Typography>
        <Typography sx={styles.content}>
          La frecuencia de las reuniones en línea o presenciales será determinada por los Directores Ejecutivos, pero no será inferior a dos
          veces por año calendario. En el caso de asuntos importantes y temporales, cualquiera de la Partes podrá convocar reuniones
          especiales del Comité en cualquier momento. En estas los miembros deberán proporcionar su nombre completo, correo electrónico y
          número de teléfono so pena de quedar descalificada para la reunión.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.comiteDirectivo}>
          Comité Directivo Conjunto
        </Typography>
        <Typography sx={styles.content}>
          Esta figura será la encargada de supervisar la implementación y las operaciones cotidianas del Acuerdo de Alianza Estratégica
          estará compuesto por dos Gerentes de la Alianza, uno representante del Estado y otro de Google, junto con seis Interesados
          Técnicos, incluyendo representantes de Presidencia, CNR y tres de Google, así como un presidente y un secretario.
        </Typography>

        <Typography sx={styles.content}>Las responsabilidades del Comité incluyen:</Typography>
        <List sx={styles.list}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Supervisar las actividades de la Alianza, realizar seguimiento del progreso y presentar informes clave al Comité Ejecutivo." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Administrar el flujo de trabajo, revisar la legislación, recibir comentarios sobre leyes y regulaciones específicas para el uso de servicios en la nube, emitir recomendaciones de reformas legales no vinculantes." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Coordinar presentaciones detalladas de Google y sus Afiliadas." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Coordinar y administrar el Proyecto de Infraestructura de Nube, resolviendo conflictos y escalando al Comité Ejecutivo si es necesario." />
          </ListItem>
        </List>

        <Typography sx={styles.content}>
          Los Gerentes de la Alianza tendrán la responsabilidad adicional de discutir cualquier cesión del Acuerdo a una Afiliada de Google
          y escalar conflictos al Comité Directivo Conjunto (CDC).
        </Typography>
        <Typography sx={styles.content}>
          Operarán con una reunión al mes en línea a menos que los Gerentes acuerden lo contrario. Podrán nombrar un presidente para cada
          reunión, según lo dispongan. En estas los miembros deberán proporcionar su nombre completo, correo electrónico y número de
          teléfono so pena de quedar descalificada para la reunión.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.decisiones}>
          Decisiones
        </Typography>
        <Typography sx={styles.content}>
          Cada grupo de administración proporcionará la aprobación o decisión o tomará dicha decisión por consenso (todas requerirán de una
          votación unánime). Ningún grupo de administración o representante de una Parte tiene la autoridad de tomar medidas que sean
          incompatibles con los términos expresados en el Acuerdo de la Alianza o para modificar o alterar los términos de la misma.
        </Typography>

        <Typography sx={styles.title} ref={contentRefs.acuerdoMaestro}>
          Acuerdo Maestro de Google Cloud - Cloud Master Agreement (CMA)
        </Typography>
        <Typography sx={styles.content}>
          El objetivo de este Acuerdo Maestro es facilitar la provisión de servicios específicos de Google al Gobierno de El Salvador, de
          conformidad con los términos acordados. Este acuerdo integral incluye términos generales, anexos de servicios, y formularios de
          pedido que definen los compromisos mínimos, las obligaciones del cliente, restricciones de uso, términos de pago, y procedimientos
          de facturación y disputas. Además, se detallan las responsabilidades de ambas partes en relación con la propiedad intelectual, la
          confidencialidad, la indemnización por daños, y las limitaciones de responsabilidad, estableciendo un marco legal que sirva como
          base en la transformación digital del Estado salvadoreño.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.caracteristicas}>
          Características de la Identificación
        </Typography>
        <Typography sx={styles.content}>
          Google otorga a la Autoridad una licencia mundial no exclusiva, no sublicenciable, no transferible, libre de regalías para
          utilizar las características de identificación de Google de acuerdo con las directrices de marcas comerciales de Google.
          <Link href="https://about.google/brand-resource-center/" target="_blank" rel="noopener noreferrer" sx={styles.referenceLink}>
            1
          </Link>
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.responsabilidad}>
          Responsabilidad
        </Typography>
        <Typography sx={styles.content}>
          Google (a) no tendrá ninguna responsabilidad ante ninguna entidad que no sea la Autoridad en virtud de este Acuerdo de Alianza, y
          (b) sólo tendrá responsabilidad ante la Autoridad en la medida en que la Autoridad haya sufrido pérdidas o daños debido al
          incumplimiento por parte de Google frente al Acuerdo.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.vigenciaTerminacion}>
          Vigencia y Terminación
        </Typography>
        <Typography sx={styles.content}>
          Este acuerdo continuará durante siete años, pero se puede extender según acuerden las partes para cumplir con las obligaciones que
          hayan quedado pendientes. En cualquier momento, cualquiera de las Partes podrá terminar el Acuerdo sin Causa con una notificación
          previa por escrito de 60 días a la otra Parte. Asimismo, las partes pueden terminar por incumplimiento grave, para lo cual la
          Autoridad tendrá 30 días para subsanar y Google 90.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.confidencialidad}>
          Confidencialidad
        </Typography>
        <Typography sx={styles.content}>
          El Receptor solo utilizará la Información Confidencial de la Parte Divulgadora para ejercer sus derechos y cumplir con sus
          obligaciones bajo el acuerdo. Además, deberá usar un cuidado razonable para proteger contra la divulgación de la Información
          Confidencial de la Parte Divulgadora.
        </Typography>
        <Typography sx={styles.content}>
          A pesar de otras disposiciones del acuerdo, el Receptor puede divulgar la Información Confidencial de la Parte Divulgadora a:
        </Typography>

        <List sx={styles.list}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Sus Afiliados, empleados y agentes autorizados que necesiten conocer la información y que estén sujetos a obligaciones de confidencialidad tan protectoras como las de esta sección." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Con el consentimiento por escrito de la Parte Divulgadora." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Coordinar y administrar el Proyecto de Infraestructura de Nube, resolviendo conflictos y escalando al Comité Ejecutivo si es necesario.Según sea estrictamente necesario para cumplir con un Proceso Legal, sujeto a la sección 10.2." />
          </ListItem>
        </List>

        <Typography sx={styles.content}>
          Responsabilidad por Acciones de Afiliados: Cada Parte es responsable de cualquier acción de sus Afiliados, empleados y agentes
          autorizados que violen esta sección de confidencialidad.
        </Typography>
        <Typography sx={styles.content}>
          Proceso Legal: Si el Receptor recibe un Proceso Legal para la Información Confidencial de la Parte Divulgadora, debe:
        </Typography>

        <List sx={styles.list}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Notificar inmediatamente a la Parte Divulgadora antes de la divulgación, a menos que esté legalmente prohibido hacerlo." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Intentar redirigir al tercero para que solicite la información directamente de la Parte Divulgadora." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Cumplir con las solicitudes razonables de la Parte Divulgadora para oponerse a la divulgación de su Información Confidencial." />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Hacer esfuerzos comercialmente razonables para objetar, limitar o modificar cualquier Proceso Legal que el Receptor determine razonablemente que es demasiado amplio, desproporcionado, incompatible con las leyes aplicables o de otra manera ilegal." />
          </ListItem>
        </List>

        <Typography sx={styles.content}>
          Confidencialidad del Acuerdo: El acuerdo y las discusiones en virtud del mismo se consideran Información Confidencial. Cada Parte
          tiene derecho a someter el documento a sus respectivos procesos internos de protección de Información Confidencial según la
          legislación de origen de cada
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.cesionSubcontratacion}>
          Cesión y subcontratación
        </Typography>
        <Typography sx={styles.content}>
          Ninguna de las Partes podrá ceder ninguna porción del Acuerdo sin el consentimiento previo por escrito de la otra Parte, no
          obstante Google podrá ceder cualquier parte de este Acuerdo, siempre que; (i) el cesionario hubiese acordado por escrito estar
          obligado por los términos del Acuerdo; (ii) la Parte cedente haya notificado a la otra Parte de la cesión; y (iii) la Parte
          cedente siga siendo responsable de las obligaciones en virtud del Acuerdo de Alianza.
        </Typography>
        <Typography sx={styles.content}>
          Asimismo, Google podrá subcontratar obligaciones en virtud del Acuerdo de Alianza a un Subcontratista, previa notificación a la
          Autoridad, pero seguirá siendo responsable antela Autoridad por cualquier obligación subcontratada y será responsable de todos los
          actos y omisiones de dicho subcontratista en relación con las obligaciones de Google en virtud de la Alianza.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.leyAplicable}>
          Ley aplicable y resolución de controversias
        </Typography>
        <Typography sx={styles.content}>
          El acuerdo se regirá conforme a la Ley de California en el idioma inglés. Todas las Controversias que permanezcan sin resolver 60
          días después de la recepción por el Comité Ejecutivo de una notificación por escrito de la Controversia será referidas y
          finalmente resueltas por arbitraje administrado por el Centro Internacional de Resolución de Disputas, de conformidad con su
          Reglamento de Arbitraje Internacional.
        </Typography>
        <Typography sx={styles.content}>
          El arbitraje será escuchado por un solo árbitro cuando el monto sea inferior a US$ 10.000.000, o por un panel de 3 árbitros cuando
          el monto sea superior.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.impuestos}>
          Impuestos
        </Typography>
        <Typography sx={styles.content}>
          El Cliente podrá retener los impuestos necesarios si este proporciona el recibo válido que acredite los impuestos retenidos.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.controversiaFacturas}>
          Controversia sobre las facturas
        </Typography>
        <Typography sx={styles.content}>
          Las instituciones podrán disputar tarifas facturadas si estas consideran de buena fe que las tarifas fueron facturadas de forma
          incorrecta. Estas controversias deberán enviarse a <Link href="mailto:collections@google.com">collections@google.com</Link> e
          identificar todas las cantidades disputadas y los motivos de la controversia. Google revisará de buena fe todas las controversias
          y proporcionará una explicación de las mismas. Si la factura es enviada antes de la fecha de vencimiento de pago, la institución
          deberá pagar únicamente las cantidades no sujetas a la controversia. Si se comprueba que se facturó de forma incorrecta Google
          emitirá una nota de crédito en favor de la institución o proveerá un reembolso a la institución con el importe facturado
          incorrectamente cuando no existan facturas futuras.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.pagosVencidos}>
          Pagos vencidos
        </Typography>
        <Typography sx={styles.content}>
          Para aquellos pagos vencidos Google podrá cobrar intereses sobre los montos vencidos a una tasa del 0.1% mensual (o la tasa más
          alta permitida por ley, si es menor) comenzando a contar desde el día 30 de la fecha de vencimiento del pago hasta que se pague
          por competo y, podrá suspender los servicios.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.propiedadIntelectual}>
          Propiedad Intelectual
        </Typography>
        <Typography sx={styles.content}>
          La institución conservará todos los Derechos de Propiedad Intelectual sobre los datos de esta y las aplicaciones, y Google
          conservará todos los Derechos de Propiedad Intelectual sobre los Servicios y el Software.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.exencionResponsabilidad}>
          Exención de responsabilidad
        </Typography>
        <Typography sx={styles.content}>
          Google (a) no otorga garantías de ningún tipo, ya sea explícita o implícita, legal o de otro tipo, incluso garantías de
          comerciabilidad, idoneidad para un uso determinado, no violación o uso ininterrumpido y sin errores de los Servicios o del
          Software; y (b) no realiza declaración alguna sobre el contenido o la información a que se puede acceder a través de los
          Servicios.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.vigenciaTerminacion}>
          Vigencia y Terminación
        </Typography>
        <Typography sx={styles.content}>
          A menos que se rescinda antes de acuerdo con sus términos, el contrato tiene una vigencia de 10 años a partir de la Fecha de
          Entrada en Vigor.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.terminacionConveniencia}>
          Terminación por Conveniencia
        </Typography>
        <Typography sx={styles.content}>
          Sujeto a cualesquiera compromisos financieros de un Formulario de Pedido o Adenda al Contrato, la institución podrá dar terminado
          el contrato o formulario de pedido por cualquier motivo mediante notificación por escrito a Google con 30 días de anticipación.
        </Typography>
        <Typography sx={styles.content}>
          Cualquier parte puede terminar un Formulario de Pedido si la otra parte ha incumplido sustancialmente el Anexo de Servicios
          aplicable y no subsana dicho incumplimiento dentro de los 30 días posteriores a la recepción de una notificación escrita.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.cesion}>
          Cesión
        </Typography>
        <Typography sx={styles.content}>
          Sujeto a cualesquiera compromisos financieros de un Formulario de Pedido o Adenda al Contrato, la institución podrá dar terminado
          el contrato o formulario de pedido por cualquier motivo mediante notificación por escrito a Google con 30 días de anticipación.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.fuerzaMayor}>
          Fuerza Mayor
        </Typography>
        <Typography sx={styles.content}>
          Ninguna de las partes será responsable por incumplimientos o demoras en el cumplimiento de sus obligaciones en la medida en que
          hayan sido ocasionados por circunstancias que estén fuera de su control razonable, planificación de contingencia incluyendo caso
          fortuito, desastres naturales, terrorismo, disturbios o guerra (un &quot;Evento de Fuerza Mayor&quot;). Para reducir los riesgos
          de una falla o retraso por fuerza mayor, cada parte implementará planes apropiados de continuidad del negocio y recuperación ante
          desastres, y los revisará y actualizará con la frecuencia necesaria para garantizar una protección razonable en todo momento
          contra dichos riesgos. Ambas partes harán esfuerzos razonables para mitigar el efecto de un evento de fuerza mayor.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.cesionSubcontratacion}>
          Cesión
        </Typography>
        <Typography sx={styles.content}>
          Google podrá subcontratar obligaciones en virtud del Contrato, pero permanecerá siendo responsable ante el Cliente por las
          obligaciones subcontratadas.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.firmasElectronicas}>
          Firmas Electrónicas
        </Typography>
        <Typography sx={styles.content}>
          Las Partes consienten el uso de firmas electrónicas, incluido DocuSign, para los fines del Acuerdo.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.afiliadas}>
          Afiliadas
        </Typography>
        <Typography sx={styles.content}>
          Cualquier institución afiliada, que posea un acuerdo activo de Servicios de Google Cloud Platform con Google será elegible para
          recibir el Descuento de Compromiso Mínimo proporcionado al Cliente. Estos tienen 5 días hábiles para entrar en vigencia.
        </Typography>

        <Typography sx={styles.title} ref={contentRefs.descuentos}>
          Descuentos
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.descuentoEnterprise}>
          Descuento Enterprise
        </Typography>
        <Typography sx={styles.content}>
          Durante el Período de Descuento, las instituciones recibirán un descuento del 20% sobre el precio de lista vigente para las SKUs
          Enterprise Agreement 2021.1 que figuran en la Lista de Grupos de SKU y Servicios Elegibles Adicionales.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.porcentajesDescuento}>
          Porcentajes de descuento
        </Typography>
        <List sx={styles.listBall}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Stantard On-Denamnd VMs … 27%" />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Network Egress … 50%" />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="Security Command Center … 20%" />
          </ListItem>
        </List>

        <Typography sx={styles.subTitle} ref={contentRefs.descuentoComputeEngine}>
          Descuento de Compute Engine Flex CUD
        </Typography>
        <Typography sx={styles.content}>
          Las instituciones podrán adquirir Compromisos de Uso Continuo Flexible de Compute Engine (“Flex CUDs”) para recibir el descuento
          porcentual fijo aplicable especificado a continuación:
        </Typography>

        <List sx={styles.listBall}>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="1 año Flex CUD … 1.369863% (21.0958904%-28% Descuento efectivo total)" />
          </ListItem>
          <ListItem sx={styles.listItem}>
            <ListItemText primary="3 años Flex CUD … 26.0273973% (40.8219178%-46% Descuento efectivo total) " />
          </ListItem>
        </List>

        <Typography sx={styles.subTitle} ref={contentRefs.descuentoPrecioFijo}>
          Descuento de precio fijo para GDC-E SKU
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={styles.table}>
            <TableHead>
              <TableRow>
                <TableCell>Service / Servicio</TableCell>
                <TableCell>Price / Precio</TableCell>
                <TableCell>Unit / Unidad</TableCell>
                <TableCell>Description / Descripcion</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>GDC-E Base - 5 Year</TableCell>
                <TableCell>23,207 USD</TableCell>
                <TableCell>per rack/month</TableCell>
                <TableCell>Rack Hardware + Border Networking Equipment</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>GDC-E Expansion - 5 Year</TableCell>
                <TableCell>21,559 USD</TableCell>
                <TableCell>per rack/month</TableCell>
                <TableCell>Rack Hardware + Border Networking Equipment</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Networking - Bandwidth</TableCell>
                <TableCell>22,244 USD</TableCell>
                <TableCell>per 10G/month</TableCell>
                <TableCell>1x10G Bandwidth - Connectivity back to GCP</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Networking-IP</TableCell>
                <TableCell>18,000 USD</TableCell>
                <TableCell>per 10G/month</TableCell>
                <TableCell>1x10G IP Port - Connectivity to Internet</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Datacenter</TableCell>
                <TableCell>86,333 USD</TableCell>
                <TableCell>per 10kW/month</TableCell>
                <TableCell>100kW Datahall S&P + 100kW Datahall Fitout</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography sx={styles.subTitle} ref={contentRefs.descuentosLooker}>
          Descuentos de Looker
        </Typography>
        <Typography sx={styles.content}>
          Las instituciones recibirán un descuento del 30 % sobre el precio de lista vigente por los Servicios Looker.
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={styles.table}>
            <TableHead>
              <TableRow>
                <TableCell>Service / Servicio</TableCell>
                <TableCell>Monthly List Price (USD) / Precio de Lista Mensual (USD)</TableCell>
                <TableCell>Monthly Unit Rate (USD) / Tarifa por Unidad Mensual</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Platform Advanced - Looker Hosted LookerPlatformHostedAdvanced</TableCell>
                <TableCell>USD 10,000.00</TableCell>
                <TableCell>USD 7,000.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Standard User - Looker Hosted LookerUserHostedInternalStandard</TableCell>
                <TableCell>USD 60.00</TableCell>
                <TableCell>USD 42.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Networking - BandViewer User - Looker Hostedwidth</TableCell>
                <TableCell>USD 30.00</TableCell>
                <TableCell>USD 21.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>LookerUserInternalViewer</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Developer user - Looker Hosted LookerUserHostedInternalAdmin</TableCell>
                <TableCell>USD 125.00</TableCell>
                <TableCell>USD 87.50</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography sx={styles.subTitle} ref={contentRefs.descuentosChronicle}>
          Descuentos de Chronicle
        </Typography>
        <Typography sx={styles.content}>
          Las instituciones recibirán un descuento del 20 % sobre el precio de lista vigente por los Servicios Chronicle
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={styles.table}>
            <TableHead>
              <TableRow>
                <TableCell>Service / Servicio</TableCell>
                <TableCell>List Price (Annual) / Precio de Lista (Anual)</TableCell>
                <TableCell>Discount (%) / Descuento (%)</TableCell>
                <TableCell>Discounted Price / Precio Descuentado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Chronicle SecOps Enterprise US Subscription SKU Subscriptions/LogIngestBytes/Enter prise/US</TableCell>
                <TableCell>2.40/GB</TableCell>
                <TableCell>20.00%</TableCell>
                <TableCell>1.92/GB</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography sx={styles.subTitle} ref={contentRefs.descuentosMandiant}>
          Descuentos de Mandiant
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={styles.table}>
            <TableHead>
              <TableRow>
                <TableCell>SKU</TableCell>
                <TableCell>Product Description</TableCell>
                <TableCell>Billing Frequency</TableCell>
                <TableCell>Price List</TableCell>
                <TableCell>Discount</TableCell>
                <TableCell>Discount Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>MA-ASM-BAS E</TableCell>
                <TableCell>Mandiant Advantage Attack Surface Management Base Subscription</TableCell>
                <TableCell>Annual</TableCell>
                <TableCell>USD 74,500.00</TableCell>
                <TableCell>20%</TableCell>
                <TableCell>USD 59,600.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>MA-ASM</TableCell>
                <TableCell>Mandiant Advantage Attack Surface Management</TableCell>
                <TableCell>Annual per Node</TableCell>
                <TableCell>USD 22.00</TableCell>
                <TableCell>20%</TableCell>
                <TableCell>USD 17.60</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>AIA-INTL</TableCell>
                <TableCell>AIA Com and GovINTL</TableCell>
                <TableCell>Annual</TableCell>
                <TableCell>USD 820,880.00</TableCell>
                <TableCell>20%</TableCell>
                <TableCell>USD 663,104.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>DIGITAL-THRE AT- MONITORING- MANAGED</TableCell>
                <TableCell>Mandiant Threat Intelligence Digital Threat Monitoring Managed Service</TableCell>
                <TableCell>Annual</TableCell>
                <TableCell>USD 159,000.00</TableCell>
                <TableCell>20%</TableCell>
                <TableCell>USD 127,200.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>PROACTIVE- SUPPORT</TableCell>
                <TableCell>Proactive Analyst Support</TableCell>
                <TableCell>Annual</TableCell>
                <TableCell>USD 159,000.00</TableCell>
                <TableCell>20%</TableCell>
                <TableCell>USD 127,200.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>CS-IR-HR*</TableCell>
                <TableCell>CS Incident Response Hourly Rate - Retainer</TableCell>
                <TableCell>Hours</TableCell>
                <TableCell>USD 500.00</TableCell>
                <TableCell>40%</TableCell>
                <TableCell>USD 300.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>CS-IR-2H-SLA</TableCell>
                <TableCell>2H Incident Response Service Level Agreement</TableCell>
                <TableCell>Annual</TableCell>
                <TableCell>USD 26,000.00</TableCell>
                <TableCell>3.85%</TableCell>
                <TableCell>USD 25,000.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>CS-IRPS</TableCell>
                <TableCell>Incident Response Preparedness Service (IRPS)</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>USD 24,000.00</TableCell>
                <TableCell>0%</TableCell>
                <TableCell>USD 24,000.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>MD-CV-BASE</TableCell>
                <TableCell>MD Full Coverage Base</TableCell>
                <TableCell>Annual</TableCell>
                <TableCell>USD 148,400.00</TableCell>
                <TableCell>37%</TableCell>
                <TableCell>USD 93,492.00</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>MD-CV-NODE</TableCell>
                <TableCell>MD Full Coverage per Node</TableCell>
                <TableCell>Annual per Node</TableCell>
                <TableCell>USD 10.60</TableCell>
                <TableCell>38%</TableCell>
                <TableCell>USD 6.57</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography sx={styles.subTitle} ref={contentRefs.aplicacionDescuentos}>
          Aplicación de Descuentos
        </Typography>
        <Typography sx={styles.content}>
          Cuando hay más de un descuento disponible para el mismo SKU, se aplicará solo el descuento que resulte en el precio más bajo.
          Además, los descuentos porcentuales se suman a cualquier compromiso de uso continuo existente, siempre que no se indique lo
          contrario.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.exclusionesDescuentos}>
          Exclusiones de Descuentos
        </Typography>
        <Typography sx={styles.content}>
          Los descuentos no aplican a los artículos que figuran en la &quot;Lista de Exclusiones&quot; accesible a través de la dirección
          web proporcionada, a partir de la fecha de implementación. Esto incluye los ítems que se añadan posteriormente a la lista y que no
          tenían descuentos asignados para el cliente en el momento de su inclusión. Esta regla se aplica a menos que se especifique lo
          contrario para un SKU específico o un grupo de SKUs de un producto determinado.
        </Typography>

        <Typography sx={styles.subTitle} ref={contentRefs.extensionDescuentos}>
          Extensión de Descuentos a Nuevos Servicios y SKUs
        </Typography>
        <Typography sx={styles.content}>
          Google tiene la libertad de extender los descuentos mencionados en este documento a nuevos servicios y SKUs que ofrezca, siempre y
          cuando estos se categoricen de manera similar. En tales casos, el descuento aplicable se mostrará en la Consola de Administración
          y se aplicará durante el resto del período de descuento estipulado
        </Typography>

        <Typography sx={styles.title} ref={contentRefs.modificaciones}>
          Modificaciones
        </Typography>
        <Typography sx={styles.content}>
          Salvo que se describa específicamente lo contrario en el Contrato, las modificaciones al Contrato deben hacerse por escrito,
          establecer explícitamente que modifican el Contrato y estar firmadas por ambas partes.
        </Typography>

        <Typography sx={styles.title} ref={contentRefs.infraestructura}>
          Infraestructura digital
        </Typography>
        <Typography sx={styles.content}>
          Esta Alianza representa un paso significativo hacia la modernización digital del Estado salvadoreño. A través de este Acuerdo,
          ambas partes se comprometen a colaborar en la implementación de soluciones tecnológicas avanzadas, enfocadas en la optimización de
          recursos y la mejora de la ciberseguridad, apoyando así la transformación digital del país. La estructura administrativa detallada
          en el documento garantiza una gestión eficiente y transparente del proyecto, ofreciendo un marco robusto para resolver posibles
          controversias y facilitar el acceso de las instituciones a servicios tecnológicos de vanguardia. Esta iniciativa no solo fortalece
          la infraestructura digital de El Salvador, sino que también promueve un uso sostenible y eficiente de la tecnología en beneficio
          del desarrollo nacional.
        </Typography>
      </CardContent>
    </MainCard>
  );
};

export default AllianceView;
